import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Row, Col } from "antd";
import { useTranslation } from "react-i18next";
import { CheckCircleOutlined } from "@ant-design/icons";

import Logo from "../../image/PROCEM3.svg";
import { authUserData } from "../../utils/Helper";
import { ErrorNotificationMsg } from "../../utils/Notifications";
import { patchRequest } from "../../axios";  // Make sure patchRequest is imported

const PaymentSuccessPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [countdown, setCountdown] = useState(5);

  const query = new URLSearchParams(location.search);
  const razorpayPaymentId = query.get("razorpay_payment_id");
  const razorpayPaymentLinkId = query.get("razorpay_payment_link_id");
  const razorpayPaymentLinkStatus = query.get("razorpay_payment_link_status");

  useEffect(() => {
    const handlePaymentSubmit = async () => {
      if (!razorpayPaymentId || !razorpayPaymentLinkId || !razorpayPaymentLinkStatus) {
        ErrorNotificationMsg(t("Invalid payment details."));
        return;
      }

      const payload = {
        razorpay_payment_id: razorpayPaymentId,
        razorpay_payment_link_id: razorpayPaymentLinkId,
        razorpay_payment_link_status: razorpayPaymentLinkStatus,
        company: authUserData()?.company_id,
      };

      try {
        await patchRequest("payment-subscription/update-payment-data/", payload);

        // Update local auth user data
        const userData = authUserData();
        if (userData) {
          userData.active_subscription = true;
          localStorage.setItem("auth_data", JSON.stringify(userData));
        }
      } catch (error) {
        ErrorNotificationMsg(error);
      }
    };

    handlePaymentSubmit();
  }, [razorpayPaymentId, razorpayPaymentLinkId, razorpayPaymentLinkStatus, t]);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev === 1) {
          clearInterval(timer);
          navigate("/purchased-subscriptions");
        }
        return prev > 0 ? prev - 1 : 0;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="authPage text-center">
      <div className="logorow headerlogin">
        <a href="/login">
          <img src={Logo} alt="Logo" className="logo" />
        </a>
      </div>

      <div className="container payment-success-container">
        <div className="login_wraper passwordsuccess">
          <div className="login-box">
            <div className="imageverify">{/* Optional success image */}</div>
            <div className="pagename">
              <CheckCircleOutlined style={{ fontSize: "48px", color: "#52c41a" }} />
              <h4>{t("Congratulations!")}</h4>
            </div>

            <Row>
              <Col span={24} className="otptext">
                <p>{t("payment_successful")}</p>
                <strong>{t("Redirecting in")} {countdown} {t("seconds...")}</strong>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;
